import request from "../../utils/request-axios";
import api from "../../utils/api";

//页面文档列表
export function getDocumentPage(params) {
  return request(`${api.getDocumentPage}`, {
    loading: true,
    method: 'get',
    data: params,
  })
}

//根据ID查询
export function queryDocument(params) {
  return request(`${api.queryDocument}${params}`, {
    loading: true,
    method: 'get',
  })
}

//编辑文档链接
export function editDocumentPage(params) {
  return request(`${api.editDocumentPage}`, {
    loading: true,
    method: 'put',
    data: params,
    promptMessage: "编辑成功!",
  })
}



// WEBPACK FOOTER //
// ./src/services/file/filePage.js